import React, { useContext, useState } from 'react';
import { Grid, Paper, Typography, Box, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Add } from '@mui/icons-material';
import { PatientTabsContext } from '../../../lib/contexts';
import { AdminProgressBar } from '../../../components/AdminProgressBar';
import { AdminChip } from '../../../components/AdminChip';
import AddPatientToListDialog from '../../../components/AddPatientToListDialog/AddPatientToListDialog';
import { useNavigate } from 'react-router-dom';
import useMetric from '../../../lib/hooks/useMetric';

const useStyles = makeStyles((theme) => ({
  patientChartCard: theme.globalClasses.patientChartCard,
  container: {
    maxHeight: 120,
    overflowY: 'scroll',
  },
  topBar: {
    // marginBottom:5
  },
  addList: {
    fontSize: 18,
    marginBottom: -5,
    fontWeight: 'bold',
  },
}));

const PatientListsBox = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const {
    state: { currentTab },
    actions: { goListTab },
  } = useContext(PatientTabsContext);
  const { isLoading, data, refetch } = useMetric('patient_lists', currentTab.id);
  const [addingPatient, setAddingPatient] = useState(false);

  return (
    <Grid
      item
      xs={12}
    >
      <Paper className={classes.patientChartCard}>
        <Grid
          item
          container
          xs={12}
          className={classes.topBar}
        >
          <Grid
            item
            xs={10}
          >
            <Typography variant={'h2'}>On Following Lists</Typography>
          </Grid>
          <Grid
            item
            xs={2}
            className="print-hide"
          >
            <Typography variant={'h3'}>View All</Typography>
          </Grid>
        </Grid>
        {isLoading ? (
          <AdminProgressBar />
        ) : (
          <Box className={classes.container}>
            {data &&
              data.metric &&
              data.metric.value.map((item, index) => (
                <AdminChip
                  key={index}
                  label={item.list_name}
                  clickable
                  onClick={() => goListTab(item.id)}
                />
              ))}
            <div
              className="print-hide"
              style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
              <Button
                variant="contained"
                sx={{
                  bgcolor: 'primary.main',
                  color: 'primary.contrastText',
                  borderRadius: '20px',
                  '&:hover': {
                    bgcolor: 'primary.dark',
                  },
                }}
                startIcon={<Add className={classes.addList} />}
                onClick={() => setAddingPatient(true)}
              >
                Add
              </Button>
            </div>
          </Box>
        )}
        <AddPatientToListDialog
          open={addingPatient}
          patient={currentTab}
          handleClose={() => setAddingPatient(false)}
          refetch={refetch}
        />
      </Paper>
    </Grid>
  );
};

export default PatientListsBox;
